/**
 * Explore / Global Drive: ask to add another restaurant on the same trip.
 * Keep false — one restaurant per trip. Same-stop “Add more items” stays on
 * (trip plan / Current trips) regardless of this flag.
 */
export const DRIVE_MULTI_STOP_ENABLED = false;

